import { Form, Formik } from 'formik';
import * as bd from 'react-basic-design';
import { AccessRoleDTO } from '../../../api/access-role-api';
import { AccessTeamDTO } from '../../../api/access-team-api';
import { AccessTeamRoleDTO } from '../../../api/access-team-role-api';
import SvgClose from '../../../assets/icons/Close';
import SvgDelete from '../../../assets/icons/Delete';
import SvgSave from '../../../assets/icons/Save';
import { BasicModal } from '../../../components/basic/basic-modal';
import { T } from '../../../components/basic/text';
import { yup } from '../../../components/basic/yup';
import { FormikTextField } from '../../../components/formik';

interface SaveAccessTeamRoleModalProps {
    show: boolean;
    allowEdit: boolean;
    selectedAccessTeamRole?: AccessTeamRoleDTO;
    accessRoles: AccessRoleDTO[];
    accessTeams: AccessTeamDTO[];
    onHide: () => void;
    onSave: (values: AccessTeamRoleDTO) => void;
    onDelete?: (accessTeamRole: AccessTeamRoleDTO) => void;
}

export function SaveAccessTeamRoleModal({
    show,
    allowEdit,
    selectedAccessTeamRole,
    accessRoles,
    accessTeams,
    onHide,
    onSave,
    onDelete,
}: SaveAccessTeamRoleModalProps) {
    const AccessTeamRoleSchema = yup.object().shape({
        roleId: yup.string().required(' '),
        accessTeamSerial: yup.number().required(' '),
        permissionLevel: yup.string(),
    });

    const defaultValues: AccessTeamRoleDTO = {
        roleId: selectedAccessTeamRole ? selectedAccessTeamRole.roleId : '',
        accessTeamSerial: selectedAccessTeamRole ? selectedAccessTeamRole.accessTeamSerial : 0,
        permissionLevel: selectedAccessTeamRole ? selectedAccessTeamRole.permissionLevel : '',
    };

    if (!show) return <></>;

    return (
        <Formik
            initialValues={defaultValues}
            validationSchema={AccessTeamRoleSchema}
            onSubmit={onSave}
        >
            {formik => (
                <BasicModal
                    show={show}
                    onHide={onHide}
                    size="xl"
                    title={
                        <bd.Flex className="w-100" align="center" content="between">
                            <T>
                                {selectedAccessTeamRole
                                    ? 'edit-access-team-role'
                                    : 'new-access-team-role'}
                            </T>
                            <bd.Flex align="center" gap={2}>
                                <bd.Button
                                    variant="icon"
                                    size="sm"
                                    onClick={formik.submitForm}
                                    disabled={!allowEdit}
                                >
                                    <SvgSave />
                                </bd.Button>
                                {selectedAccessTeamRole && onDelete && (
                                    <bd.Button
                                        disabled={!allowEdit}
                                        variant="icon"
                                        color="secondary"
                                        size="sm"
                                        onClick={() => onDelete(selectedAccessTeamRole)}
                                    >
                                        <SvgDelete />
                                    </bd.Button>
                                )}
                                <bd.Button
                                    variant="icon"
                                    color="secondary"
                                    size="sm"
                                    onClick={onHide}
                                >
                                    <SvgClose />
                                </bd.Button>
                            </bd.Flex>
                        </bd.Flex>
                    }
                >
                    <Form>
                        <bd.Flex align="center" wrap>
                            <FormikTextField
                                label="role-id"
                                name="roleId"
                                readOnly={!allowEdit || !!selectedAccessTeamRole}
                                type="select"
                                items={[
                                    { id: null, title: '' },
                                    ...accessRoles.map(accessRole => ({
                                        id: accessRole.id,
                                        title: `${accessRole.title} `,
                                    })),
                                ]}
                                width="11rem"
                                handleEnter
                            />

                            <FormikTextField
                                label="access-team-serial"
                                name="accessTeamSerial"
                                readOnly={!allowEdit || !!selectedAccessTeamRole}
                                type="select"
                                items={[
                                    { id: null, title: '' },
                                    ...accessTeams.map(accessTeam => ({
                                        id: accessTeam.serial,
                                        title: `${accessTeam.title} `,
                                    })),
                                ]}
                                width="11rem"
                                handleEnter
                            />

                            <FormikTextField
                                label="permission-level"
                                name="permissionLevel"
                                readOnly={!allowEdit}
                                width="11rem"
                                handleEnter
                            />
                        </bd.Flex>
                    </Form>
                </BasicModal>
            )}
        </Formik>
    );
}
